export const CATALOG_BLOCK_TYPES = {
    product: "product",
    link: "link",
    image: "image",
    text: "text",
    social: "social"
};

export const CATALOG_BLOCK_TYPE_OPTIONS = [
    {
        id: CATALOG_BLOCK_TYPES.product,
        name: "Producto",
        icon: "🛍️",
        description: "Muestra uno o varios productos de tu catálogo"
    },
    {
        id: CATALOG_BLOCK_TYPES.link,
        name: "Link",
        icon: "🔗",
        description: "Un enlace externo con etiqueta, ej. un video de YouTube"
    },
    {
        id: CATALOG_BLOCK_TYPES.image,
        name: "Imagen",
        icon: "🖼️",
        description: "Una imagen o banner"
    },
    {
        id: CATALOG_BLOCK_TYPES.text,
        name: "Texto",
        icon: "📝",
        description: "Un título y una descripción"
    },
    {
        id: CATALOG_BLOCK_TYPES.social,
        name: "Redes sociales",
        icon: "📲",
        description: "Íconos de tus redes sociales ya configuradas"
    }
];

export const PLATFORM_OPTIONS = [
    { value: "", label: "Genérico" },
    { value: "youtube", label: "YouTube" },
    { value: "instagram", label: "Instagram" },
    { value: "tiktok", label: "TikTok" },
    { value: "facebook", label: "Facebook" },
    { value: "whatsapp", label: "WhatsApp" },
    { value: "twitter", label: "X / Twitter" },
    { value: "linkedin", label: "LinkedIn" },
    { value: "twitch", label: "Twitch" },
    { value: "pinterest", label: "Pinterest" },
    { value: "threads", label: "Threads" }
];

export const generateBlockId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `block-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

const createBlockConfig = (type) => {
    switch (type) {
        case CATALOG_BLOCK_TYPES.product:
            return { mode: "single", title: "", productIds: [], products: [] };
        case CATALOG_BLOCK_TYPES.link:
            return {
                mode: "single",
                customLinkId: "",
                platform: "",
                showInHeader: true
            };
        case CATALOG_BLOCK_TYPES.image:
            return { image: null, url: "" };
        case CATALOG_BLOCK_TYPES.text:
            return { title: "", description: "" };
        case CATALOG_BLOCK_TYPES.social:
            return { mode: "selected", networkKeys: [], showInHeader: true };
        default:
            return {};
    }
};

export const createBlock = (type, weight) => ({
    id: generateBlockId(),
    type,
    weight,
    enabled: true,
    config: createBlockConfig(type)
});

export const resequenceWeights = (blocks) =>
    blocks.map((block, index) => ({ ...block, weight: index }));

export const migrateLandingSectionsToBlocks = (landingSections = []) =>
    landingSections.map((description, index) => ({
        id: generateBlockId(),
        type: CATALOG_BLOCK_TYPES.text,
        weight: index,
        enabled: true,
        config: { title: "", description }
    }));
